// source: pbtypes/gen/flight_connect/device_node_peer_remote_tx_link_stats.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_flight_connect_transport_type_pb = require('../../../pbtypes/gen/flight_connect/transport_type_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_transport_type_pb);
goog.exportSymbol('proto.flight_connect.DeviceNodePeerRemoteTxLinkStats', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_connect.DeviceNodePeerRemoteTxLinkStats, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.displayName = 'proto.flight_connect.DeviceNodePeerRemoteTxLinkStats';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.toObject = function(includeInstance, msg) {
  var f, obj = {
srcLink: jspb.Message.getFieldWithDefault(msg, 1, 0),
txPackets: jspb.Message.getFieldWithDefault(msg, 2, 0),
remoteToLocalMs: jspb.Message.getFieldWithDefault(msg, 3, 0),
txPacketsLost: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats}
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_connect.DeviceNodePeerRemoteTxLinkStats;
  return proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats}
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.flight_connect.TransportType.Enum} */ (reader.readEnum());
      msg.setSrcLink(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTxPackets(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRemoteToLocalMs(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTxPacketsLost(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSrcLink();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTxPackets();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getRemoteToLocalMs();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTxPacketsLost();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional TransportType.Enum src_link = 1;
 * @return {!proto.flight_connect.TransportType.Enum}
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.prototype.getSrcLink = function() {
  return /** @type {!proto.flight_connect.TransportType.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.flight_connect.TransportType.Enum} value
 * @return {!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats} returns this
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.prototype.setSrcLink = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional uint32 tx_packets = 2;
 * @return {number}
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.prototype.getTxPackets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats} returns this
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.prototype.setTxPackets = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 remote_to_local_ms = 3;
 * @return {number}
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.prototype.getRemoteToLocalMs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats} returns this
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.prototype.setRemoteToLocalMs = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 tx_packets_lost = 4;
 * @return {number}
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.prototype.getTxPacketsLost = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.DeviceNodePeerRemoteTxLinkStats} returns this
 */
proto.flight_connect.DeviceNodePeerRemoteTxLinkStats.prototype.setTxPacketsLost = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


goog.object.extend(exports, proto.flight_connect);
